import { ReactNode } from 'react';
import tw from 'twin.macro';

import { TagDetailsCellType } from '@insights_module/types/Megaphone';
import { CheckMarkIcon } from '@icons/CheckMarkIcon';

const Flex = tw.div`w-full flex items-center justify-start gap-2 px-4`;
const DetailsContainer = tw.div`w-full max-w-[193px] text-left ml-2`;
const Title = tw.span`w-full block text-[14px] text-left leading-4 font-semibold text-text-and-icon truncate mb-[4px]`;
const Description = tw.p`text-left text-[11px] font-medium leading-[140%] text-text-and-icon-muted line-clamp-2`;

const CheckboxWrapper = tw.button`flex items-center justify-center cursor-pointer`;
const StyledCheckbox = tw.div`w-[13px] h-[13px] min-w-[13px] min-h-[13px] border border-solid border-text-and-icon-muted rounded-sm flex items-center justify-center p-0`;

const Checkbox = ({
  onChange,
  checked,
  title,
  children,
}: {
  onChange: () => void;
  checked: boolean;
  title: string;
  children?: ReactNode;
}) => {
  return (
    <CheckboxWrapper onClick={onChange} title={title}>
      <StyledCheckbox css={[checked && tw`bg-accent-muted border-accent-muted`]}>
        {checked ? <CheckMarkIcon tw='stroke-neutral-background w-2 h-2' /> : ''}
      </StyledCheckbox>
      {children}
    </CheckboxWrapper>
  );
};

export const DetailsCell = (
  item: TagDetailsCellType,
  setSelectedRows: (item: string[]) => void,
  selectedRows: string[]
): JSX.Element => {
  const { title, tag_id, description } = item;

  const handleChange = () => {
    setSelectedRows(
      selectedRows?.includes(tag_id as never)
        ? selectedRows.filter((item) => item !== tag_id)
        : [...selectedRows, tag_id]
    );
  };

  return (
    <Flex>
      <Checkbox
        checked={selectedRows?.includes(tag_id as never)}
        onChange={handleChange}
        title={title}>
        <DetailsContainer>
          <Title title={title}>{title}</Title>
          {description && <Description title={description}>{description}</Description>}
        </DetailsContainer>
      </Checkbox>
    </Flex>
  );
};
